/** Emergency-contact wording shared by the call sheet and the contacts page. */

import type { EmergencyContact } from "../api/emergencyContacts";

export const RELATIONSHIP_LABELS: Record<EmergencyContact["relationship"], string> = {
  family: "Family",
  friend: "Friend",
  doctor: "Doctor",
  other: "Other",
};

/** "Family · Mother", or just "Family" without a label. */
export const relationshipText = (c: Pick<EmergencyContact, "relationship" | "relationship_label">): string =>
  c.relationship_label ? `${RELATIONSHIP_LABELS[c.relationship]} · ${c.relationship_label}` : RELATIONSHIP_LABELS[c.relationship];
